import React, { useEffect } from "react";
import styled, { keyframes } from "styled-components";
import { Link, useNavigate, useParams } from "react-router-dom";
import Caroussel from "../../components/core-components/Caroussel.tsx";

import {
  addNewProduct,
  getTechnicProductDetails,
  updateImage,
  updateProductData,
  uploadImage,
} from "../../../services/productsService.js";
import { useQuery } from "@tanstack/react-query";
import Button from "../../components/core-components/Button.tsx";

import Cips from "../../components/core-components/Cips.tsx";

import { TbRulerMeasure2 } from "react-icons/tb";
import { GiFilmSpool } from "react-icons/gi";

import { toast, ToastContainer } from "react-toastify";
import PageHeader from "../../components/PageHeader.tsx";
import InputField from "../../components/core-components/InputField.tsx";
import SimpleDropdown from "../../components/core-components/SimpleDropdown.tsx";
import { getFilaments } from "../../../services/filamentService.js";
import { IoIosLock } from "react-icons/io";
import { useAuth } from "../../../hooks/useAuth.jsx";
import Table from "../../components/core-components/Table.tsx";
import { URLPOZE } from "../../../utils/constants.ts";
import { AiOutlineHome } from "react-icons/ai";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  align-items: center;
  gap: 1rem;
  width: 100%;
  height: 100%;
`;

const ProductDetailsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 2rem;

  @media (max-width: 768px) {
    flex-direction: column;
  }

  & > div {
    flex: 1;
  }
`;

const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 1300px) {
    max-width: 40%;
  }
`;

const CarouselContainer = styled.div`
  width: 100%;
  max-width: 550px;
`;

const DetailsRow = styled.div`
  font-family: Georgia, serif;

  color: var(--secondary-font-color);
  font-size: 14px;
`;
const CipsRow = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;
  gap: 8px;
  padding: 12px 0;
  font-size: 12px;
  flex-wrap: wrap;
`;
const PriceRow = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;
  gap: 10%;
  font-family: Georgia, serif;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
`;
const Price = styled.p`
  font-family: Georgia, serif;
  color: var(--secondary-font-color);
  font-size: 20px;
`;

const ProductPrice = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;

const StrikePrice = styled.div`
  font-family: Verdana, sans-serif;
  text-decoration: line-through;
  color: var(--tertiary-font-color);
  font-size: 0.8rem;
`;

const DetailsText = styled.p`
  text-align: justify;
  line-height: 1.5;
  padding: 4px 0;
  margin: 0;
`;

const ProductName = styled.p`
  font-size: 24px;
  font-family: Georgia, serif;
  padding: 4px 0 16px 0;
  margin: 0;
`;
const Image = styled.img`
  width: 100%;
  height: 300px;
`;

const pulse = keyframes`
  0% {
    background-color: #e0e0e0;
  }
  50% {
    background-color: #c0c0c0;
  }
  100% {
    background-color: #e0e0e0;
  }
`;

const SkeletonImage = styled.div`
  margin-bottom: 16px;
  width: 100%;
  height: 300px;
  background-color: #e0e0e0;
  border-radius: 4px;
  animation: ${pulse} 1.5s infinite ease-in-out;
`;

const Content = styled.div`
  box-sizing: border-box;
  background-color: white;
  width: calc(100% - 2rem);
  height: 100vh;
  border-radius: 8px;
  padding: 20px;
  overflow-x: auto; /* Enable horizontal scroll */
  overflow-y: auto; /* Optional: keep vertical scroll */

  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
`;

const SwitchLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  cursor: pointer;
`;

const SwitchInput = styled.input`
  width: 40px;
  height: 20px;
  position: relative;
  appearance: none;
  background: #c6c6c6;
  outline: none;
  border-radius: 20px;
  transition: 0.3s;

  &:checked {
    background: var(--primary-brown);
  }

  &::before {
    content: "";
    position: absolute;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    top: 1px;
    left: 1px;
    background: white;
    transition: 0.3s;
  }

  &:checked::before {
    left: 21px;
  }
`;
const Breadcrumbs = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  color: var(--tertiary-font-color);
  padding-bottom: 12px;
  width: 100%;
  font-size: 14px;

  & > a {
    color: var(--tertiary-font-color);
    cursor: pointer;
    align-items: center;
    display: flex;
  }
`;

const SettingsLineWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 0;
  font-size: 12px;

  & > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    padding: 12px 0;
    font-size: 12px;
    align-items: end;
  }

  & > p {
    font-size: 14px;
    font-weight: bold;
    color: var(--secondary-font-color);
    margin: 0;
  }
`;

const ProductDetailsPage = () => {
  const { productId, categoryId } = useParams();
  const { token } = useAuth();
  const navigate = useNavigate();
  const [isCustomize, setIsCustomize] = React.useState(false);
  const [name, setName] = React.useState("Nume produs");
  const [description, setDescription] = React.useState("Descriere produs");
  const [price, setPrice] = React.useState(0);
  const [discount, setDiscount] = React.useState(0);
  const [type, setType] = React.useState("");
  const [category, setCategory] = React.useState("Categorie");
  const [height, setHeight] = React.useState(0);
  const [depth, setDepth] = React.useState(0);
  const [weight, setWeight] = React.useState(0);
  const [width, setWidth] = React.useState(0);
  const [imageUrls, setImageUrls] = React.useState([]);
  const [isListed, setIsListed] = React.useState(false);
  const [stock, setStock] = React.useState(0);
  const [showSaveButton, setShowSaveButton] = React.useState(false);

  const { data: product, refetch } = useQuery({
    queryKey: ["productDetails", productId],
    queryFn: () => getTechnicProductDetails(productId),
    retry: false,
    enabled: !!productId && productId !== "new",
  });

  const { data: filaments } = useQuery({
    queryKey: ["filaments"],
    queryFn: getFilaments,
  });
  // const product = {
  //   productId: 1,
  //   productName: "Product 1",
  //   description: "Description of product 1",
  //   productWeight: 100,
  //   productHeight: 80,
  //   productDepth: 100,
  //   price: 100,
  //   colorName: "Red",
  //   typeName: "Type 1",
  //   categoryName: "Category 1",
  //   customize: true,
  //   imageUrls: [],
  //   discount: 10,
  //   isListed: true,
  // };

  useEffect(() => {
    if (product && productId && productId !== "new") {
      setName(product?.productName);
      setDescription(product?.description);
      setPrice(product?.price);
      setDiscount(product?.discount);
      setType(product?.typeName);
      setCategory(product?.categoryName);
      setHeight(product?.productHeight);
      setDepth(product?.productDepth);
      setWeight(product?.materialWeight);
      setWidth(product?.productWeight);
      setImageUrls(product?.imageUrls);
      setIsListed(product?.isListed);
      setIsCustomize(product?.customize);
      setStock(product?.stockNumber);
    } else {
      setName("Nume produs");
      setDescription("Descriere produs");
      setPrice(0);
      setDiscount(0);
      setType("");
      setCategory("Categoria " + categoryId);
      setHeight(0);
      setDepth(0);
      setWeight(0);
      setWidth(0);
      setImageUrls([]);
      setIsListed(true);
      setIsCustomize(false);
      setStock(0);
    }
  }, [productId, product, product?.productName, categoryId]);

  useEffect(() => {
    if (product && productId && productId !== "new") {
      //e update

      if (
        (price > 0 && price !== product?.price) ||
        discount !== product?.discount ||
        isListed !== product?.isListed ||
        stock != product?.stockNumber
      ) {
        setShowSaveButton(true);
      } else {
        setShowSaveButton(false);
      }
    } else {
      if (
        name &&
        price &&
        description &&
        type &&
        height &&
        depth &&
        weight &&
        width
      ) {
        setShowSaveButton(true);
      } else {
        setShowSaveButton(false);
      }
    }
  }, [
    name,
    price,
    description,
    type,
    category,
    height,
    depth,
    weight,
    width,
    imageUrls,
    discount,
    isListed,
    isCustomize,
    categoryId,
    product,
    productId,
    setShowSaveButton,
    stock,
  ]);
  const notify = (msg) =>
    toast.success(msg, {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: "light",
    });

  const notifyErr = () =>
    toast.success("S-a produs o eroare!", {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: "light",
    });

  const isSizeCompatible = (printer) => {
    return (
      printer.bedHeight >= height &&
      printer.bedDepth * printer.bedWidth >= width * depth
    );
  };
  const handleSave = async () => {
    if (productId && productId !== "new") {
      // Update product logic
      try {
        await updateProductData(
          productId,
          isListed,
          price,
          discount,
          stock,
          token
        );
        notify("Produs actualizat cu succes");
      } catch (error) {
        console.error("Error updating order status:", error);
        notifyErr();
      }
    } else {
      // Create new product logic

      const newProduct = {
        productName: name,
        description: description,
        price: price,
        materialWeight: weight,
        productHeight: height,
        productWeight: width,
        productDepth: depth,
        discount: discount,
        customize: isCustomize,
        isListed: isListed,
        productImage: null,
        categoryID: categoryId,
        filamentID: type,
        stock: stock,
      };

      try {
        const response = await addNewProduct(newProduct);
        imageUrls.forEach((image) => {
          uploadImage(image, response.productID);
        });
        navigate(
          `/backoffice/category/${categoryId}` ///product/${response.productID}
        );
        return response.productID;
      } catch (error) {
        console.error("Error creating color:", error);
      }
    }
  };

  const addImage = (image: File) => {
    setImageUrls((prevImages) => {
      if (prevImages) {
        return [...prevImages, image];
      } else {
        return [image];
      }
    });
  };

  const replaceImage = async (image: File, id: number) => {
    try {
      const response = await updateImage(image, id);
      refetch();
      return response.productID;
    } catch (error) {
      console.error("Error creating color:", error);
    }
  };

  const handleImages = (images) => {
    return images.map((image, index) => (
      <Image key={index} src={`${URLPOZE}${image}`} alt={`Product ${index}`} />
    ));
  };

  return (
    <Wrapper>
      <PageHeader pageTitle="Detalii produs" />
      <Content>
        <Breadcrumbs>
          <Link to={"/backoffice/category"}>Toate categoriile</Link>{" "}
          <>
            {" "}
            {">"}{" "}
            <Link to={`/backoffice/category/${categoryId}`}>
              {product?.categoryName}{" "}
            </Link>{" "}
            {">"} <div>{product?.productName}</div>
          </>
        </Breadcrumbs>
        <ProductDetailsContainer>
          <CarouselContainer>
            <Caroussel
              content={
                product && product.imageUrls?.length > 0
                  ? handleImages(product.imageUrls)
                  : [<SkeletonImage />]
              }
            />
          </CarouselContainer>

          <DetailsContainer>
            <DetailsRow data-testid="product-category">
              <DetailsText
                style={{ textTransform: "uppercase", fontSize: "12px" }}
              >
                {category}
              </DetailsText>
            </DetailsRow>

            <DetailsRow data-testid="product-title">
              <ProductName>{name}</ProductName>
            </DetailsRow>
            {product && productId !== "new" && (
              <DetailsRow data-testid="product-category">
                <DetailsText style={{ fontSize: "12px" }}>
                  ID produs: {product?.productID}
                </DetailsText>
              </DetailsRow>
            )}
            <DetailsRow data-testid="product-description">
              <DetailsText>{description}</DetailsText>
            </DetailsRow>

            {product && (
              <CipsRow>
                <Cips
                  color="var(--primary-brown)"
                  inverted
                  text={type}
                  icon={<GiFilmSpool style={{ fontSize: "16px" }} />}
                />
                <Cips
                  color="var(--primary-brown)"
                  inverted
                  icon={<TbRulerMeasure2 />}
                  text={`${width} x ${depth} x ${height} mm`}
                />
              </CipsRow>
            )}

            <PriceRow>
              <>
                {discount ? (
                  <ProductPrice data-testid="product-price">
                    <Price>
                      {Number(price) - Number(price) * (Number(discount) / 100)}{" "}
                      lei
                    </Price>
                    <StrikePrice>{price} lei</StrikePrice>
                  </ProductPrice>
                ) : (
                  <Price>{price} lei</Price>
                )}
              </>
            </PriceRow>
          </DetailsContainer>
        </ProductDetailsContainer>
        <div>
          <SettingsLineWrapper>
            <p>Informatii generale</p>
            <div>
              <div
                style={{
                  width: "40%",
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                }}
              >
                <InputField
                  name="name"
                  type="text"
                  label={"Nume produs"}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder={"Nume produs"}
                  isRequired
                  readonly={productId !== "new"}
                />

                <InputField
                  name="price"
                  type="number"
                  label={"Preț"}
                  value={price.toString()}
                  onChange={(e) => setPrice(Number(e.target.value))}
                  placeholder={"100 lei"}
                  isRequired
                />
                <InputField
                  name="discount"
                  type="number"
                  label={"Reducere %"}
                  value={discount.toString()}
                  onChange={(e) => setDiscount(Number(e.target.value))}
                  placeholder={"20%"}
                  isRequired
                />
              </div>

              <InputField
                name="description"
                type="textarea"
                label={"Descriere produs"}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder={"Descriere produs"}
                isRequired
                readonly={productId !== "new"}
              />
            </div>
          </SettingsLineWrapper>

          <SettingsLineWrapper>
            <p>Setări</p>
            <div>
              <div style={{ width: "20%" }}>
                <SimpleDropdown
                  values={
                    filaments &&
                    filaments.map((filament) => ({
                      value: filament.filamentConfig.filamentID,
                      label: `id ${filament.filamentConfig.filamentID} - ${filament.filamentConfig.material} - ${filament.colorName}`,
                    }))
                  }
                  label="Filament"
                  name="supplier"
                  icon={<GiFilmSpool />}
                  onChange={({ value, label }) => setType(value)}
                  readonly={productId !== "new"}
                  currentValue={
                    product?.filamentID
                      ? {
                          value: product.filamentID,
                          label: `id ${product.filamentID} - ${product.typeName} - ${product.colorName}`,
                        }
                      : undefined
                  }
                />
              </div>
              <div style={{ width: "20%" }}>
                <InputField
                  name="weight"
                  type="number"
                  label={"Cantitate material"}
                  value={weight.toString()}
                  onChange={(e) => setWeight(Number(e.target.value))}
                  placeholder={"200g"}
                  isRequired
                  readonly={productId !== "new"}
                />
              </div>
              <div style={{ width: "20%" }}>
                <InputField
                  name="stock"
                  type="number"
                  label={"Stoc disponibil"}
                  value={stock.toString()}
                  onChange={(e) => setStock(Number(e.target.value))}
                  placeholder={"3"}
                />
              </div>

              <SwitchLabel>
                <SwitchInput
                  type="checkbox"
                  checked={isCustomize}
                  onChange={() => {
                    if (productId === "new") {
                      setIsCustomize(!isCustomize);
                    }
                  }}
                  disabled={productId !== "new"}
                />
                {productId !== "new" && <IoIosLock />} Customizabil
              </SwitchLabel>
              <SwitchLabel>
                <SwitchInput
                  type="checkbox"
                  checked={isListed}
                  onChange={() => {
                    setIsListed(!isListed);
                  }}
                />
                Listat
              </SwitchLabel>
            </div>
          </SettingsLineWrapper>
          {productId === "new" && (
            <SettingsLineWrapper>
              <p>Imagini</p>
              <div>
                <input
                  type="file"
                  onChange={(e) =>
                    e.target.files && addImage(e.target.files[0])
                  }
                />
                <input
                  type="file"
                  onChange={(e) =>
                    e.target.files && addImage(e.target.files[0])
                  }
                />
                <input
                  type="file"
                  onChange={(e) =>
                    e.target.files && addImage(e.target.files[0])
                  }
                />
              </div>
            </SettingsLineWrapper>
          )}

          {productId !== "new" && imageUrls?.length > 0 && (
            <SettingsLineWrapper>
              <p>Imagini</p>
              <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
                {imageUrls.map((img, index) => (
                  <div
                    key={index}
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <div>{img}</div>
                    <input
                      type="file"
                      onChange={(e) => {
                        if (e.target.files) {
                          console.log(product?.imageIds[index]);
                          replaceImage(
                            e.target.files[0],
                            product?.imageIds[index]
                          );
                        }
                      }}
                    />
                  </div>
                ))}
              </div>
            </SettingsLineWrapper>
          )}

          <SettingsLineWrapper>
            <p>Dimensiuni produs</p>
            <div>
              <InputField
                name="weight"
                type="number"
                label={"Lungime /mm"}
                value={width.toString()}
                onChange={(e) => setWidth(Number(e.target.value))}
                placeholder={"100 mm"}
                isRequired
                readonly={productId !== "new"}
              />
              <InputField
                name="depth"
                type="number"
                label={"Lățime /mm"}
                value={depth.toString()}
                onChange={(e) => setDepth(Number(e.target.value))}
                placeholder={"100 mm"}
                isRequired
                readonly={productId !== "new"}
              />
              <InputField
                name="height"
                type="number"
                label={"Înălțime /mm"}
                value={height.toString()}
                onChange={(e) => setHeight(Number(e.target.value))}
                placeholder={"100 mm"}
                isRequired
                readonly={productId !== "new"}
              />
            </div>
          </SettingsLineWrapper>
        </div>
        {showSaveButton && (
          <Button
            id="save-printer-button"
            onClick={handleSave}
            text={"Save"}
            backgroundColor={"var(--secondary-green)"}
            color="white"
            isFullWidth
          />
        )}

       {/* this feature was crated in scop of disseration and was disable in  production */}
        {/* <SettingsLineWrapper>
          <p>Imprimante compatibile pentru filamentul produsului</p>
          <Table
            columns={[
              { title: "ID", key: "printerID" },
              { title: "Nume", key: "name" },

              { title: "Lungime", key: "bedWidth" },
              { title: "Latime", key: "bedDepth" },
              { title: "Inaltime", key: "bedHeight" },

              { title: "Se imprimă dintr-o bucată", key: "size" },
            ]}
            rows={
              product?.compatiblePrinters
                ? product?.compatiblePrinters.map((printer) => {
                    return {
                      printerID: printer.printerID,
                      name: printer.name,
                      bedHeight: printer.bedHeight + " mm",
                      bedWidth: printer.bedWidth + " mm",
                      bedDepth: printer.bedDepth + " mm",
                      size: isSizeCompatible(printer) ? "DA" : "NU",
                    };
                  })
                : []
            }
          />
        </SettingsLineWrapper> */}
      </Content>

      <ToastContainer />
    </Wrapper>
  );
};

export default ProductDetailsPage;
